module.exports = __webpack_public_path__ + "static/media/img2-4.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/biosense/diff/img2-4.png
// module id = 2196
// module chunks = 3